export default __webpack_public_path__ + "static/media/playlist.b4d1a0a1.svg";